import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import ActionModalHeader, { DemoNote, customerName } from "./ActionModalHeader";

// STATIC DESIGN — email a customer from a template (reads user_email)
const TEMPLATES: Record<string, string> = {
  "Your payment failed — update card": "Hi {name},\n\nYour last payment for UOMOX could not be processed. Please update your card to avoid interruption to your broadcasts.\n\nTeam UOMOX",
  "Your WhatsApp number quality dropped": "Hi {name},\n\nMeta has lowered the quality rating of your WhatsApp number. We recommend pausing marketing broadcasts for 48 hours and reviewing your templates.\n\nTeam UOMOX",
  "Complete your onboarding": "Hi {name},\n\nYou're almost there! Connect your WhatsApp number to start sending messages from UOMOX.\n\nTeam UOMOX",
  "Your plan is expiring soon": "Hi {name},\n\nYour UOMOX plan expires soon. Renew now to keep your campaigns and automations running.\n\nTeam UOMOX",
};

interface SendEmailModalProps { show: boolean; onHide: () => void; user: any }

const SendEmailModal = ({ show, onHide, user }: SendEmailModalProps) => {
  const [template, setTemplate] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");

  useEffect(() => { if (show) { setTemplate(""); setSubject(""); setBody(""); } }, [show]);

  const pickTemplate = (t: string) => {
    setTemplate(t);
    setSubject(t);
    setBody(t ? TEMPLATES[t].replace("{name}", user?.user_first_name || "there") : "");
  };

  const send = () => {
    if (!subject.trim() || !body.trim()) return toast.warning("Subject and message are required");
    toast.info(`Email to ${user?.user_email} · demo only, not sent`);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered contentClassName="cx">
      <ActionModalHeader icon="ri-mail-send-line" title="Send email" subtitle={`${customerName(user)} · ${user?.user_email || ""}`} onClose={onHide} />
      <div style={{ padding: "14px 20px", display: "grid", gap: 12 }}>
        <div>
          <label className="cx-label">Template</label>
          <select className="cx-select" style={{ width: "100%" }} value={template} onChange={(e) => pickTemplate(e.target.value)}>
            <option value="">Blank</option>
            {Object.keys(TEMPLATES).map(t => <option key={t}>{t}</option>)}
          </select>
        </div>
        <div>
          <label className="cx-label">Subject</label>
          <input className="cx-input" style={{ width: "100%" }} value={subject} onChange={(e) => setSubject(e.target.value)} />
        </div>
        <div>
          <label className="cx-label">Message</label>
          <textarea className="cx-input" rows={6} value={body} onChange={(e) => setBody(e.target.value)}></textarea>
        </div>
        <DemoNote />
      </div>
      <div style={{ padding: "0 20px 18px", display: "flex", justifyContent: "flex-end", gap: 8 }}>
        <button type="button" className="cx-btn cx-btn-light" onClick={onHide}>Cancel</button>
        <button type="button" className="cx-btn cx-btn-primary" onClick={send}><i className="ri-send-plane-line"></i>Send</button>
      </div>
    </Modal>
  );
};

export default SendEmailModal;
